// Should only be imported by tests

expect.extend({
  toBeWithContext(received, expected, context) {
    const ctx = JSON.stringify(context)
    const expectedDisplay = JSON.stringify(expected)
    const receivedDisplay = JSON.stringify(received)
    const message = () =>
      `expected ${ctx} to return ${expectedDisplay}, ` +
      `but it returned ${receivedDisplay}`

    return {
      message,
      pass: received === expected,
    }
  },
})
